import { Size } from 'react-easy-crop';

import { styled } from '@/primitives';

export const ImageDropWrapper = styled('div')<{ cropSize: Size }>`
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.palette.background.default};
  width: 100%;
  flex: 1;
  min-height: 0;
  align-items: stretch;
`;

export const PreviewImageWrapper = styled('div')<{ cropSize: Size }>`
  position: relative;
  width: 100%;
  flex: 1;
  min-height: 300px;
`;

export const ZoomControlWrapper = styled('div')<{ width: number }>`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 32px 24px 12px;
  box-sizing: border-box;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.55), rgba(0, 0, 0, 0));
`;
